export default "__VITE_ASSET__DjDxrapO__"